import { toLocalDate, toLocalDateTime } from "../../utils/to-local-date";

import type { Number } from "@sperrdatei/dto/types";

type FullNumberCheckResultProps = {
  number: Number | undefined;
  searchedNumber: string;
};

export const FullNumberCheckResult: React.FC<FullNumberCheckResultProps> = ({
  number,
  searchedNumber,
}: FullNumberCheckResultProps) => {
  return (
    <div className="col-xxl-7 col-xl-7 col-lg-10 col-xs-12 mt-0 p-0">
      <table className="table">
        <tbody>
          <tr className="border border-0">
            <td className="border border-0 ps-0" colSpan={3}>
              Rufnummer:{" "}
              {number ? (
                <strong>
                  0{number.prefix}-{number.number}
                </strong>
              ) : (
                <strong>{searchedNumber}</strong>
              )}
            </td>
          </tr>
          <tr>
            <td
              colSpan={2}
              className={number ? "ps-0" : "border border-0 ps-0"}
            >
              Status:
            </td>
            <td className={number ? "text-end" : "border border-0 text-end"}>
              <strong>{number ? "Eingetragen" : "Nicht eingetragen"}</strong>
            </td>
          </tr>
          {number ? (
            <tr>
              <td colSpan={2} className="ps-0">
                Erfasst am
              </td>
              <td
                className="text-end"
                title={number ? toLocalDateTime(number.created) : ""}
              >
                {number ? toLocalDate(number.created) : ""}
              </td>
            </tr>
          ) : null}
          {number ? (
            <tr>
              <td colSpan={2} className="ps-0">
                Art
              </td>
              <td className="text-end">
                {number ? (number.private ? "Privat" : "Gewerblich") : ""}
              </td>
            </tr>
          ) : null}
          {number ? (
            <tr>
              <td colSpan={2} className="ps-0">
                Gesperrt für
              </td>
              <td className="text-end">
                {number
                  ? number.blockType === "alle_befragungen"
                    ? "Alle Befragungen"
                    : "Bevölkerungsbefragungen"
                  : ""}
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
};
